import React from 'react';

type FormSelectProps = {
    label: string;
    name: string;
    value?: string;
    onChange?: (value: string) => void;
    options: string[];
    error?: string;
    placeholder?: string;
    disabled?: boolean;
};

const FormSelect = ({ label, name, value, onChange, options, error, placeholder, disabled }: FormSelectProps) => {
    return (
        <div className="mb-4">
            <label
                htmlFor={name}
                className="block text-sm font-medium mb-1.5"
                style={{ color: 'var(--text-secondary)' }}
            >
                {label}
            </label>
            <select
                id={name}
                name={name}
                value={value || ''}
                onChange={(e) => onChange?.(e.target.value)}
                disabled={disabled}
                className="input-base"
                style={{ cursor: 'pointer' }}
            >
                {placeholder && <option value="">{placeholder}</option>}
                {options.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                ))}
            </select>
            {error && (
                <p className="text-xs mt-1" style={{ color: 'var(--danger)' }}>{error}</p>
            )}
        </div>
    );
};

export default FormSelect;
